module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "receipt_edit"
  }, [_c('div', {
    staticClass: "changead"
  }, [_c('div', {
    staticClass: "inputdata"
  }, [_c('div', {
    staticClass: "changeadinput"
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "margin-right": "20px"
    }
  }, [_vm._v("修改发票状态")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sumbitEdit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.closeEdit()
      }
    }
  }, [_vm._v("取消")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-d2826934"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receiptEdit.vue
// module id = 552
// module chunks = 1